module.exports = __webpack_public_path__ + "static/media/waterpolo.2097ae2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/waterpolo.svg
// module id = 405
// module chunks = 7